import * as actions from "./actionTypes";
import { toast } from 'react-toastify';

const initialState = {
    allBanksLoading: false,
    allBanks: [],
};


export default function reducer(state = initialState, action) {
    switch (action.type) {

        case actions.GET_BANKS:
            state = {
                ...state,
                allBanksLoading: false,
                allBanks: [...action.payload.data]
            }
            return state;


        case actions.GET_BANKS_START:
            state = {
                ...state,
                allBanksLoading: true,
            }
            return state;


        case actions.GET_BANKS_FAILED:
            if (action.payload.message === "Validation Errors") {
                const payloadErrors = action.payload.errors;
                Object.keys(payloadErrors).forEach(function (key) {
                    for (let i = 0; i < payloadErrors[key].length; i++) {
                        toast.error(payloadErrors[key][i]);
                    }
                });
            }
            else {
                toast.error(action.payload.message);
            }

            state = {
                ...state,
                allBanksLoading: false,
                allBanks: [],
            }
            return state;


        default:
            return state;
    }
}